var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @desc tooltip
 */
import * as lodash from '../../utils/lodash';
import { Group } from '../../element';
import ComponentModel from '../../model/componentModel';
import { getDefaultCrosshairOption } from '../axis/axis';
import { getPlotInfoAtPoint, getPlotAxis } from '../../utils/plot';
import { plotEvents, tooltipEvents } from '../../action';
import { getPadding } from '../../utils/styleHelper';
import { registerComponent } from '../index';
import { renderCanvasTooltip } from './helper';
import template from '../../utils/template';
import ReactTooltipRenderer from './ReactTooltipRenderer';
import VueTooltipRenderer from './VueTooltipRenderer';
import Vue3TooltipRenderer from './Vue3TooltipRenderer';
var TooltipRenderer = /** @class */ (function () {
    function TooltipRenderer() {
    }
    return TooltipRenderer;
}());
export { TooltipRenderer };
/**
 * default
 */
var TooltipModel = /** @class */ (function (_super) {
    __extends(TooltipModel, _super);
    function TooltipModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'tooltip';
        _this.disabled = false;
        _this.group = new Group({
            key: 'tooltip-group',
            display: false,
            pointerEvents: 'none',
            zIndex: 999,
        });
        _this._justclicked = false;
        _this._positionCalled = false;
        _this.unHighlightPoints = function () {
            _this.state.points.forEach(function (point) {
                var dataIndex = point.dataIndex, seriesIndex = point.seriesIndex;
                _this.chart.getSeriesModel(seriesIndex).unhighlightPoint(dataIndex);
            });
        };
        _this.handlePointMouseOver = function (event) {
            if (!event.point) {
                return;
            }
            var _a = event.point, seriesIndex = _a.seriesIndex, plotX = _a.plotX, plotY = _a.plotY, visible = _a.visible;
            if (visible === false) {
                return;
            }
            if (_this.option.trigger === 'axis' && event.hasAxis) {
                return;
            }
            if (event.type.indexOf('click') === -1 && _this.option.triggerOn === 'click') {
                return;
            }
            if (_this.option.crosshairs && _this.option.crosshairs.type) {
                var seriesModel = _this.chart.getSeriesModel(seriesIndex);
                var dependentComponents = seriesModel.getDependentComponents();
                if (lodash.includes(dependentComponents, 'coord')) {
                    var coord = seriesModel.getCoord();
                    var categoryAxis = coord.getCategoryAxis();
                    var valueAxis = coord.getValueAxis();
                    if (_this.option.crosshairs.type === 'cross') {
                        categoryAxis.showCrosshair(plotX, plotY, 'line');
                        valueAxis.showCrosshair(plotX, plotY, 'line');
                    }
                }
            }
            _this.showTooltip({
                title: event.title,
                mouse: event.mouse,
                points: [event.point],
            });
        };
        _this.handlePointMouseMove = function (event) {
            if (_this.option.trigger === 'axis' && event.hasAxis) {
                return;
            }
            if (_this.option.triggerOn === 'click') {
                return;
            }
            if (!_this.state.visible) {
                return;
            }
            var position = _this._getPosition(event.mouse);
            _this.setPosition(position);
        };
        _this.handlePointMouseOut = function (event) {
            if (_this.option.trigger === 'axis' && event.hasAxis) {
                return;
            }
            if (_this.option.triggerOn === 'click') {
                return;
            }
            _this.hideTooltip();
        };
        /**
         * handle plot area (grid, polar) event
         * @param event mouse event
         */
        _this.handlePlotMove = function (event) {
            if (_this.state.isEnter) {
                return;
            }
            if (!_this.option.show) {
                return;
            }
            if (event.target.getDependentSeries().filter(function (seriesModel) { return seriesModel.visible(); }).length === 0) {
                return;
            }
            if (_this.option.trigger !== 'axis') {
                return;
            }
            if (event.type !== 'plot:click' && _this.option.triggerOn === 'click') {
                return;
            }
            var plotModel = event.target;
            var _a = event.mouse, x = _a.x, y = _a.y;
            // let pointerX = x;
            // let pointeY = y;
            if (plotModel.getDependentSeries().length === 0) {
                return;
            }
            var _b = getPlotInfoAtPoint(plotModel, x, y), title = _b.category, tooltipPoints = _b.points;
            var _c = getPlotAxis(plotModel), categoryAxis = _c.categoryAxis, valueAxis = _c.valueAxis;
            if (valueAxis.length === 0) {
                return;
            }
            var oldPoints = _this.state.points;
            oldPoints.forEach(function (point) {
                var seriesIndex = point.seriesIndex, dataIndex = point.dataIndex;
                if (!tooltipPoints.some(function (item) { return item.seriesIndex === seriesIndex && item.dataIndex === dataIndex; })) {
                    _this.chart.getSeriesModel(seriesIndex).unhighlightPoint(dataIndex);
                }
            });
            tooltipPoints.forEach(function (point) {
                var seriesIndex = point.seriesIndex, dataIndex = point.dataIndex;
                if (!oldPoints.some(function (item) { return item.seriesIndex === seriesIndex && item.dataIndex === dataIndex; })) {
                    _this.chart.getSeriesModel(seriesIndex).highlightPoint(dataIndex);
                }
            });
            _this.setState({
                points: tooltipPoints,
            });
            if (tooltipPoints.length > 0) {
                _this.showCrosshairs(categoryAxis, valueAxis, event);
                _this.showTooltip({
                    mouse: event.mouse,
                    title: title,
                    points: tooltipPoints,
                });
            }
            else if (_this.state.visible) {
                var position = _this._getPosition(event.mouse);
                _this.setPosition(position);
            }
        };
        _this._handleTooltipMouseEnter = function () {
            _this.setState({ visible: true, isEnter: true });
        };
        _this._handleTooltipMouseLeave = function () {
            _this.setState({ isEnter: false });
            if (_this.option.triggerOn !== 'click') {
                _this.hideTooltip();
            }
        };
        _this._handleWindowClick = function () {
            if (_this.option.triggerOn !== 'click') {
                return;
            }
            setTimeout(function () {
                if (!_this._justclicked && _this.state.isEnter === false) {
                    _this.hideTooltip();
                }
                _this._justclicked = false;
            }, 20);
        };
        _this._handleTooltipClick = function (event) {
            _this.chart.dispatchAction({
                type: 'tooltip:click',
                mouse: event,
            });
        };
        return _this;
    }
    TooltipModel.prototype.getDefaultOption = function () {
        var isBrower = this.chart.isBrowser();
        return {
            show: true,
            showContent: true,
            useCssFixedPosition: false,
            trigger: 'axis',
            triggerOn: 'mousemove',
            backgroundColor: 'rgba(255,255, 255, .95)',
            borderColor: '#333333',
            borderWidth: 0,
            borderRadius: 4,
            padding: [12, 16],
            offset: 16,
            showDelay: 0,
            hideDelay: 100,
            throttle: 100,
            transitionDuration: 200,
            allowEnter: false,
            useHTML: !!isBrower,
            alwaysShow: false,
            zIndex: 1,
            crosshairs: getDefaultCrosshairOption(),
            textStyle: {
                color: '#333333',
                fontSize: 12,
            },
            formatter: null,
            valueFormatter: function (point) {
                return point.percent !== undefined ? point.percent : point.value;
            },
            position: null,
            nameFormatter: function (point) {
                return 'name' in (point.encode || {}) ? point.name : point.seriesName;
            },
            rtl: false,
            titleFormatter: function (title) { return title; },
            reversed: false,
            shadow: true,
            minWidth: null,
            confine: !isBrower,
            sort: null,
        };
    };
    TooltipModel.prototype.init = function () {
        var _this = this;
        this._initTooltipContainer();
        this._initTooltipRenderer();
        this.registerEvent(plotEvents.PLOT_LEAVE, function () {
            if (_this.option.triggerOn === 'click') {
                return;
            }
            _this.hideTooltip();
        });
        this.registerEvent(plotEvents.PLOT_MOVE, this.handlePlotMove);
        this.registerEvent('plot:touchmove', this.handlePlotMove);
        this.registerEvent('plot:touchstart', this.handlePlotMove);
        this.registerEvent('plot:click', this.handlePlotMove);
        this.registerEvent('plot:wheel', this.handlePlotMove);
        this.registerEvent('point:mouseout', this.handlePointMouseOut);
        this.registerEvent('point:touchstart', this.handlePointMouseOver);
        this.registerEvent('point:click', this.handlePointMouseOver);
        this.registerEvent('point:touchmove', this.handlePointMouseOver);
        this.registerEvent('point:mousemove', this.handlePointMouseOver);
        this.registerEvent('label:mouseover', this.handlePointMouseOver);
        this.registerEvent('label:mousemove', this.handlePointMouseMove);
        this.registerEvent('label:mouseout', this.handlePointMouseOut);
        this.registerEvent('connectLine:mouseover', this.handlePointMouseOver);
        this.registerEvent('connectLine:mousemove', this.handlePointMouseMove);
        this.registerEvent('connectLine:mouseout', this.handlePointMouseOut);
        this.registerEvent('edge:mouseover', this.handlePointMouseOver);
        this.registerEvent('edge:click', this.handlePointMouseOver);
        this.registerEvent('edge:mousemove', this.handlePointMouseMove);
        this.registerEvent('edge:mouseout', this.handlePointMouseOut);
        this.registerEvent('zoom', this.unHighlightPoints);
        this.registerEvent('brushend', this.unHighlightPoints);
        this.setPosition = lodash.throttle(this.setPosition.bind(this), this.option.throttle);
        this.chart.getOption().tooltip = this.option;
    };
    TooltipModel.prototype.getInitialState = function () {
        return {
            visible: false,
            isEnter: false,
            points: [],
        };
    };
    TooltipModel.prototype.showCrosshairs = function (categoryAxis, valueAxis, event) {
        var crosshairs = this.option.crosshairs;
        var allAxis = categoryAxis.concat(valueAxis);
        var _a = event.mouse, x = _a.x, y = _a.y;
        var points = this.state.points;
        if (categoryAxis.length === 0) {
            x = points[0].plotX;
            y = points[0].plotY;
        }
        var hasNotLineSeries = event.target
            .getDependentSeries()
            .some(function (seriesModel) { return seriesModel.type !== 'line' && seriesModel.type !== 'area'; });
        if (!crosshairs) {
            return;
        }
        if (!crosshairs.type) {
            if (categoryAxis.length > 0) {
                if (!(event.target.type === 'polar' && !hasNotLineSeries)) {
                    categoryAxis.forEach(function (axis) { return axis.showCrosshair(x, y); });
                }
            }
            else {
                allAxis
                    .filter(function (axis) { return axis.type === 'xAxis' || axis.type === 'angleAxis'; })[0]
                    .showCrosshair(x, y);
            }
        }
        else if (crosshairs.type === 'line') {
            if (categoryAxis.length > 0) {
                categoryAxis.forEach(function (axis) { return axis.showCrosshair(x, y, 'line'); });
            }
            else {
                allAxis
                    .filter(function (axis) { return axis.type === 'xAxis' || axis.type === 'angleAxis'; })[0]
                    .showCrosshair(x, y);
            }
        }
        else if (crosshairs.type === 'shadow') {
            if (categoryAxis.length > 0) {
                categoryAxis.forEach(function (axis) { return axis.showCrosshair(x, y, 'shadow'); });
            }
        }
        else if (crosshairs.type === 'cross') {
            if (event.target.type === 'grid') {
                var xAxis = allAxis.filter(function (axis) { return axis.type === 'xAxis'; })[0];
                var yAxisArr = allAxis.filter(function (axis) { return axis.type === 'yAxis'; });
                xAxis.showCrosshair(x, y, 'line');
                yAxisArr.forEach(function (yAxis, index) {
                    return yAxis.showCrosshair(x, y, index === 0 ? 'line' : 'label');
                });
            }
            else if (event.target.type === 'polar') {
                var angleAxis = allAxis.filter(function (axis) { return axis.type === 'angleAxis'; })[0];
                var radiusAxis = allAxis.filter(function (axis) { return axis.type === 'radiusAxis'; })[0];
                angleAxis.showCrosshair(x, y, 'line');
                radiusAxis.showCrosshair(x, y, 'line');
            }
        }
    };
    TooltipModel.prototype.setContent = function (content) {
        if (content instanceof HTMLElement) {
            this._dom.innerHTML = '';
            this._dom.appendChild(content);
        }
        else {
            this._dom.innerHTML = content;
        }
    };
    TooltipModel.prototype.setPosition = function (position) {
        if (this.disposed) {
            return;
        }
        var useCssFixedPosition = this.option.useCssFixedPosition;
        if (this.state.isEnter) {
            return;
        }
        if (this.option.useHTML) {
            var dom = this.chart.getDom();
            var _a = dom.getBoundingClientRect(), clientTop = _a.top, clientLeft = _a.left;
            var _b = getComputedStyle(dom), paddingTop = _b.paddingTop, paddingLeft = _b.paddingLeft;
            var top_1 = position.y + (useCssFixedPosition ? clientTop : 0) + parseFloat(paddingTop || '0');
            var left = position.x + (useCssFixedPosition ? clientLeft : 0) + parseFloat(paddingLeft || '0');
            this._dom.style.top = (useCssFixedPosition ? Math.max(top_1, 0) : top_1) + 'px';
            this._dom.style.left = (useCssFixedPosition ? Math.max(left, 0) : left) + 'px';
            this._dom.style.right = 'auto';
            this._dom.style.bottom = 'auto';
        }
        else {
            if (this._positionCalled) {
                this.group.stopAllAnimation().animateTo({
                    position: [position.x, position.y],
                }, this.option.transitionDuration);
            }
            else {
                this.group.stopAllAnimation().setAttr({
                    position: [position.x, position.y],
                });
            }
            this._positionCalled = true;
        }
    };
    TooltipModel.prototype.showTooltip = function (tooltipParam, mute) {
        if (mute === void 0) { mute = false; }
        if (this.state.isEnter) {
            return;
        }
        var _a = this.option, show = _a.show, showContent = _a.showContent, valueFormatter = _a.valueFormatter, nameFormatter = _a.nameFormatter, titleFormatter = _a.titleFormatter, reversed = _a.reversed, sort = _a.sort;
        var visible = show && showContent;
        var param = __assign(__assign({}, tooltipParam), { valueFormatter: valueFormatter, nameFormatter: nameFormatter, titleFormatter: titleFormatter });
        if (this.disabled) {
            return;
        }
        if (sort) {
            param.points = param.points.sort(sort);
        }
        if (reversed) {
            param.points = param.points.reverse();
        }
        var mouse = param.mouse;
        this._markClicked();
        if (this.option.useHTML) {
            var content = '';
            this._dom.style.display = !visible ? 'none' : 'inline-block';
            if (!this.option.formatter) {
                param.title = titleFormatter(param.title, tooltipParam);
                content = template(this._formatterTooltip(param), param);
            }
            else if (lodash.isString(this.option.formatter)) {
                content = template(this.option.formatter, param);
            }
            else if (lodash.isFunction(this.option.formatter)) {
                // todo should not use template for performance reason
                var formatterResult = this.option.formatter(param);
                if (lodash.isString(formatterResult)) {
                    var formatterTemplate = lodash.template(formatterResult, {
                        interpolate: /<%=([\S\s]+?)%>/g,
                    });
                    content = formatterTemplate(param);
                }
                else {
                    content = formatterResult;
                }
            }
            if (!content) {
                this._dom.style.display = 'none';
                return;
            }
            if (this._customRenderer) {
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                this._customRenderer.updateCallback = setTooltipPosition.bind(this);
                this._customRenderer.update(this._dom, content, tooltipParam);
            }
            else {
                this.setContent(content);
            }
        }
        else {
            // canvas renderer
            this.group.setAttr({ display: visible });
            this.group.parentNode.add(this.group);
            renderCanvasTooltip(param, this);
        }
        if (!this._customRenderer) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            setTooltipPosition.bind(this)();
        }
        function setTooltipPosition() {
            var position = this._getPosition(mouse);
            this.setPosition(position);
            this.setState({ visible: true });
            if (!mute) {
                this.chart.dispatchAction({
                    type: tooltipEvents.TOOLTIP_SHOW,
                    mouse: mouse,
                    points: param.points,
                });
            }
        }
    };
    TooltipModel.prototype.hideTooltip = function () {
        var _this = this;
        if (this.chart.isDisposed()) {
            return;
        }
        if (this.option.alwaysShow) {
            return;
        }
        this.setState({ isEnter: false });
        this.state.points.forEach(function (point) {
            var dataIndex = point.dataIndex, seriesIndex = point.seriesIndex;
            var seriesModel = _this.chart.getSeriesModel(seriesIndex);
            if (seriesModel) {
                seriesModel.unhighlightPoint(dataIndex);
            }
        });
        var coord = this.chart.getComponentModel('coord');
        coord.polars.forEach(function (polar) { return polar.getAllAxis().forEach(function (axis) { return axis.hideCrosshair(); }); });
        coord.grids.forEach(function (grid) { return grid.getAllAxis().forEach(function (axis) { return axis.hideCrosshair(); }); });
        this.chart.dispatchAction({
            type: tooltipEvents.TOOLTIP_HIDE,
            points: this.state.points,
        });
        this.setState({ visible: false, points: [] });
        setTimeout(function () {
            if (!_this.chart || (!_this._dom && _this.option.useHTML)) {
                // may be destroy
                return;
            }
            if (_this.state.visible === false) {
                if (_this.option.useHTML) {
                    _this._dom.style.display = 'none';
                }
                else {
                    _this.group.setAttr({ display: false });
                }
                _this.chart.dispatchAction({
                    type: tooltipEvents.TOOLTIP_HIDDEN,
                    points: _this.state.points,
                });
            }
        }, this.disabled ? 0 : this.option.hideDelay);
    };
    TooltipModel.prototype.beforeRender = function () {
        this._setDomStyle();
        this.group.setAttr({
            pointerEvents: this.option.allowEnter ? 'auto' : 'none',
            onClick: this._handleTooltipClick,
            onMouseEnter: this._handleTooltipMouseEnter,
            onMouseLeave: this._handleTooltipMouseLeave,
        });
    };
    TooltipModel.prototype.render = function () {
        this.chart.addToTopLevel(this.group);
        return null;
    };
    TooltipModel.prototype.beforeDestroy = function () {
        var _a;
        (_a = this._customRenderer) === null || _a === void 0 ? void 0 : _a.destroy(this._dom);
        if (this._dom) {
            // may not bed destroyed
            this._dom.parentNode.removeChild(this._dom);
            window.removeEventListener('click', this._handleWindowClick);
            this._dom.removeEventListener('click', this._handleTooltipClick);
        }
    };
    TooltipModel.prototype.update = function (nextOption, mergeOld) {
        var _a;
        (_a = this._customRenderer) === null || _a === void 0 ? void 0 : _a.destroy(this._dom);
        _super.prototype.update.call(this, nextOption, mergeOld);
        this.disabled = false;
        this.hideTooltip();
        this._initTooltipRenderer();
    };
    TooltipModel.prototype._getPosition = function (mouse) {
        var width;
        var height;
        var _a = this.option, useHTML = _a.useHTML, confine = _a.confine;
        if (useHTML) {
            width = this._dom.clientWidth;
            height = this._dom.clientHeight;
        }
        else {
            var rect = this.group.getBBox();
            width = rect.width;
            height = rect.height;
        }
        var chartWidth = this.chart.getWidth();
        var chartHeight = this.chart.getHeight();
        var param = {
            mouse: mouse,
            tooltipWidth: width,
            tooltipHeight: height,
            chartWidth: chartWidth,
            chartHeight: chartHeight,
            points: this.state.points,
        };
        var position;
        if (lodash.isFunction(this.option.position)) {
            position = this.option.position(param);
        }
        else {
            position = this._defaultPositioner(param);
        }
        if (confine) {
            position.x = Math.min(position.x + width, chartWidth) - width;
            position.y = Math.min(position.y + height, chartHeight) - height;
            position.x = Math.max(position.x, 0);
            position.y = Math.max(position.y, 0);
        }
        return position;
    };
    TooltipModel.prototype._defaultPositioner = function (param) {
        var _a = this.option, offset = _a.offset, useCssFixedPosition = _a.useCssFixedPosition, useHTML = _a.useHTML, rtl = _a.rtl;
        var mouse = param.mouse, width = param.tooltipWidth, height = param.tooltipHeight, chartWidth = param.chartWidth, chartHeight = param.chartHeight;
        var left = mouse.x + offset;
        var top = mouse.y + offset;
        if (!useCssFixedPosition || !useHTML) {
            if (left + width > chartWidth || (rtl && mouse.x - width - offset > 0)) {
                left = mouse.x - width - offset;
            }
            if (mouse.y + height > chartHeight) {
                top = mouse.y - height - offset;
            }
        }
        else {
            var _b = this.chart.getDom().getBoundingClientRect(), clientTop = _b.top, clientLeft = _b.left;
            var innerWidth_1 = window.innerWidth;
            var innerHeight_1 = window.innerHeight;
            var _c = mouse.original, clientX = _c.clientX, clientY = _c.clientY;
            if (left + width + clientLeft > innerWidth_1 ||
                (rtl && clientX - width - offset - clientLeft > 0)) {
                left = clientX - width - offset - clientLeft;
            }
            if (top + height + clientTop > innerHeight_1) {
                top = clientY - height - offset - clientTop;
            }
        }
        return {
            x: left,
            y: top,
        };
    };
    TooltipModel.prototype._setDomStyle = function () {
        if (!this.chart.isBrowser()) {
            return;
        }
        var _a = this.option, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor, borderWidth = _a.borderWidth, borderRadius = _a.borderRadius, padding = _a.padding, useCssFixedPosition = _a.useCssFixedPosition, zIndex = _a.zIndex;
        var textStyle = this.getTextStyle(this.option.textStyle);
        var _b = getPadding(padding), paddingTop = _b.paddingTop, paddingLeft = _b.paddingLeft, paddingRight = _b.paddingRight, paddingBottom = _b.paddingBottom;
        if (useCssFixedPosition) {
            document.body.appendChild(this._dom);
        }
        else {
            this.chart.getDom().appendChild(this._dom);
        }
        var style = this._dom.style;
        style.position = useCssFixedPosition ? 'fixed' : 'absolute';
        style.paddingTop = paddingTop + "px";
        style.paddingLeft = paddingLeft + "px";
        style.paddingRight = paddingRight + "px";
        style.paddingBottom = paddingBottom + "px";
        style.backgroundColor = backgroundColor;
        style.borderColor = borderColor;
        style.borderWidth = borderWidth + "px";
        style.borderStyle = 'solid';
        style.borderRadius = borderRadius + "px";
        style.color = textStyle.fill; // todo css gradient
        style.fontSize = textStyle.fontSize + "px";
        style.lineHeight = '1';
        style.fontFamily = textStyle.fontFamily;
        style.fontWeight = textStyle.fontWeight.toString();
        style.fontStyle = textStyle.fontStyle;
        style.pointerEvents = this.option.allowEnter ? 'all' : 'none';
        style.boxShadow = this.option.shadow ? '0px 8px 16px 0px rgba(29,42,68,0.12)' : 'none';
        if (zIndex > 0) {
            style.zIndex = zIndex.toString();
        }
        this._dom.onmouseenter = this._handleTooltipMouseEnter;
        this._dom.onmouseleave = this._handleTooltipMouseLeave;
    };
    TooltipModel.prototype._initTooltipContainer = function () {
        if (!this.chart.isBrowser()) {
            return;
        }
        var transitionDuration = this.option.transitionDuration;
        var div = this.chart.addHTMLLayer("display: none;transition: all ease " + transitionDuration + "ms;white-space: nowrap;");
        div.style.transform = 'translate3d(0,0,0)';
        div.className = 'lightcharts-tooltip';
        this._dom = div;
        this._dom.addEventListener('click', this._handleTooltipClick);
        window.addEventListener('click', this._handleWindowClick);
    };
    TooltipModel.prototype._initTooltipRenderer = function () {
        if (this.option.customRenderer) {
            this._customRenderer = this.option.customRenderer({
                ReactTooltipRenderer: ReactTooltipRenderer,
                VueTooltipRenderer: VueTooltipRenderer,
                Vue3TooltipRenderer: Vue3TooltipRenderer,
            });
            this._customRenderer.init(this._dom, this.option);
        }
    };
    // eslint-disable-next-line no-unused-vars
    TooltipModel.prototype._formatterTooltip = function (param) {
        var _a = this.option, fontSize = _a.textStyle.fontSize, rtl = _a.rtl;
        if (rtl) {
            return "\n        <% if(title) {%>\n        <div class=\"lightcharts-tooltip-title\" style=\"font-weight:500;margin-bottom: 12px;text-align: right\"><%=title%></div>\n        <% }%>\n        <% points.forEach(function(point, index) {%>\n          <div class=\"lightcharts-tooltip-item\" style=\"display: table;width: 100%;white-space:nowrap;margin-bottom:<%=index !== points.length - 1 ? '12px' : '0'%>\">\n          <span style=\"display:table-cell;\"><%= valueFormatter(point) %></span>\n          <span style=\"display:table-cell;padding-left:36px;vertical-align:middle;text-align: right;\">\n          <%= nameFormatter(point) %>\n          <% if(point.dataType !== 'edge') {%><span style=\"display:inline-block;width: 6px;height:6px;background:<%=point.color%>;border-radius: 3px;float: right; margin-top: " + (fontSize / 2 - 3) + "px;margin-left:8px;\"></span><% }%>\n          </span>\n          </div>\n        <%}) %>\n      ";
        }
        return "\n      <% if(title) {%>\n      <div class=\"lightcharts-tooltip-title\" style=\"font-weight:500;margin-bottom: 12px;\"><%=title%></div>\n      <% }%>\n      <% points.forEach(function(point, index) {%>\n        <div class=\"lightcharts-tooltip-item\" style=\"display: table;width: 100%;white-space:nowrap;margin-bottom:<%=index !== points.length - 1 ? '12px' : '0'%>\">\n         <span style=\"display:table-cell;vertical-align:middle\"><% if(point.dataType !== 'edge') {%><span style=\"display:inline-block;width: 6px;height:6px;background:<%=point.color%>;border-radius: 3px;float: left; margin-top: " + (fontSize / 2 - 3) + "px;margin-right:8px;\"></span><% }%><%= nameFormatter(point) %></span>\n         <span style=\"padding-left:36px;display:table-cell;text-align: right\"><%= valueFormatter(point)%></span>\n        </div>\n      <%}) %>\n    ";
    };
    TooltipModel.prototype._markClicked = function () {
        if (this.option.triggerOn !== 'click') {
            return;
        }
        this._justclicked = true;
    };
    return TooltipModel;
}(ComponentModel));
export default TooltipModel;
registerComponent('tooltip', TooltipModel);
